module.exports = __webpack_public_path__ + "img/xmark.a3962bdf.svg";